"use client";

import { MoonStarIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";
import React, { useCallback, useEffect, useState } from "react";

import { META_THEME_COLORS } from "@/config/site";
import { useMetaColor } from "@/hooks/use-meta-color";

import { Button } from "./ui/button";

export function ToggleTheme() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  const { setMetaColor } = useMetaColor();

  // Ensure component is mounted before rendering theme-specific content
  useEffect(() => {
    setMounted(true);
  }, []);

  const handleToggle = useCallback(() => {
    setTheme(resolvedTheme === "dark" ? "light" : "dark");
    setMetaColor(
      resolvedTheme === "dark"
        ? META_THEME_COLORS.light
        : META_THEME_COLORS.dark
    );
  }, [resolvedTheme, setTheme, setMetaColor]);

  // Show a placeholder button during SSR/initial load
  if (!mounted) {
    return (
      <Button variant="outline" size="icon" disabled>
        <div className="h-4 w-4" />
        <span className="sr-only">Toggle Theme</span>
      </Button>
    );
  }

  return (
    <Button variant="outline" size="icon" onClick={handleToggle}>
      {resolvedTheme === "dark" ? (
        <MoonStarIcon className="h-4 w-4" />
      ) : (
        <SunIcon className="h-4 w-4" />
      )}
      <span className="sr-only">Toggle Theme</span>
    </Button>
  );
}
